var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMchoiceModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mchoice_modal_icon_svg__clip0_1453_6532)",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.667 5.5H17.5M6.667 10.5H17.5M6.667 15.5H17.5",
    stroke: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.5h.008M2.5 10.5h.008M2.5 15.5h.008",
    stroke: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mchoice_modal_icon_svg__clip0_1453_6532"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 9.75 10.25)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgMchoiceModalIcon;